// Suggested price / min bid preview for the admin screens.
// Mirrors the Phase 2 pricing formula; the API stays the source of truth for real orders.

export const DEFAULT_ROUNDING_STEP = 1000;

// example trip shown under the pricing fields
export const EXAMPLE_TRIP = { km: 5, minutes: 15 };

export interface IPricingInput {
  startPrice: number;
  chargePerKilometer: number;
  chargePerTraffic: number; // per minute
  minBidPct: number;
}

const roundUp = (value: number, step: number) =>
  step > 1 ? Math.ceil(value / step) * step : Math.round(value);

export const calcSuggestedPrice = (
  s: IPricingInput,
  km: number,
  minutes: number,
  roundingStep = DEFAULT_ROUNDING_STEP
) => {
  const distanceAmount = Math.round(km * s.chargePerKilometer);
  const timeAmount = Math.round(minutes * s.chargePerTraffic);
  return {
    distanceAmount,
    timeAmount,
    suggestedPrice: roundUp(s.startPrice + distanceAmount + timeAmount, roundingStep),
  };
};

// lowest price a passenger may bid, rounded up to whole thousands of kip
export const calcMinBid = (suggestedPrice: number, minBidPct: number) =>
  roundUp((suggestedPrice * minBidPct) / 100, 1000);
